export default __webpack_public_path__ + "static/media/img-0304-brazil-full-face.d55f8868.png";